import { Colors } from '../enums';

export const productColors = [
  { label: 'Lime', value: Colors.lime, color: Colors.lime },
  { label: 'Light Green', value: Colors.lime, color: Colors.lime },
  { label: 'Green', value: Colors.green, color: Colors.green },
  { label: 'Teal', value: Colors.teal, color: Colors.teal },
  { label: 'Yellow', value: Colors.yellow, color: Colors.yellow },
  { label: 'Amber', value: Colors.amber, color: Colors.amber },
  { label: 'Orange', value: Colors.orange, color: Colors.orange },
  { label: 'Deep Orange', value: Colors.deepOrange, color: Colors.deepOrange },
  { label: 'Red', value: Colors.red, color: Colors.red },
  { label: 'Pink', value: Colors.pink, color: Colors.pink },
  { label: 'Purple', value: Colors.purple, color: Colors.purple },
  { label: 'Deep Purple', value: Colors.deepPurple, color: Colors.deepPurple },
  { label: 'Indigo', value: Colors.indigo, color: Colors.indigo },
  { label: 'Light Blue', value: Colors.lightBlue, color: Colors.lightBlue },
  { label: 'Blue', value: Colors.blue, color: Colors.blue },
  { label: 'Brown', value: Colors.brown, color: Colors.brown },
  { label: 'Brown Dark', value: Colors.brownDark, color: Colors.brownDark },
  { label: 'Brown Light', value: Colors.brownLight, color: Colors.brownLight },
];

export const defaultProductColor = Colors.deepPurple;
